import { render, staticRenderFns } from "./MAccountFrame.vue?vue&type=template&id=25f1120c&"
import script from "./MAccountFrame.ts?vue&type=script&lang=ts&"
export * from "./MAccountFrame.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports